import { motion } from 'framer-motion';
import {
  Home, Grid3X3, Receipt, ClipboardList, Bell, Users,
  FileText, Settings, ChevronRight, ChevronDown, ChevronsLeft, Monitor, CheckCircle2
} from 'lucide-react';

const navItems = [
  { icon: Home, label: 'Home', active: true, hasArrow: true },
  { icon: Grid3X3, label: 'Mandatory tariffs', hasArrow: true },
  { icon: Receipt, label: 'Transactions', hasArrow: true },
  { icon: ClipboardList, label: 'Surveys', hasArrow: true },
  { icon: Bell, label: 'Notification engine', hasArrow: true },
  { icon: Users, label: 'Manage', hasArrow: true },
  { icon: FileText, label: 'Resources', hasArrow: true },
];

export default function NewUserLoggedInScene() {
  return (
    <div data-testid="scene-new-user-logged-in" className="flex items-start justify-center h-full w-full overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-[1280px] h-[560px] bg-white rounded-2xl border border-black/5 shadow-2xl overflow-hidden flex"
      >
        {/* Sidebar */}
        <motion.aside
          initial={{ x: -30, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="w-[220px] bg-[#FAFAFA] border-r border-[#E5E7EB] flex flex-col flex-shrink-0"
        >
          <div className="px-4 py-4 flex items-center gap-2 border-b border-[#E5E7EB]">
            <div className="w-7 h-7 rounded-md bg-teal-600 flex items-center justify-center">
              <span className="text-white font-heading font-bold text-[10px]">S</span>
            </div>
            <span className="font-heading font-bold text-sm text-[#0A0A0A] tracking-tight">Shafafiya</span>
          </div>
          <nav className="flex-1 py-2 px-2 space-y-0.5 overflow-y-auto">
            {navItems.map((item, i) => (
              <motion.div key={item.label}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 + i * 0.05 }}
                className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-[13px] font-body ${
                  item.active ? 'bg-teal-600 text-white font-medium' : 'text-[#737373]'
                }`}
              >
                <item.icon size={16} />
                <span className="flex-1">{item.label}</span>
                <ChevronRight size={14} className={item.active ? '' : 'opacity-40'} />
              </motion.div>
            ))}
          </nav>
          <div className="border-t border-[#E5E7EB] px-2 py-2 space-y-1">
            <div className="flex items-center gap-2 px-3 py-1.5 text-[12px] font-body text-[#737373]"><ChevronsLeft size={14} /><span>Collapse menu</span></div>
            <div className="flex items-center gap-2 px-3 py-1.5 text-[13px] font-body text-[#737373]"><Settings size={16} /><span>Settings</span></div>
            <div className="flex items-center gap-2.5 px-3 py-2">
              <div className="w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center flex-shrink-0"><span className="text-white text-[10px] font-bold">AA</span></div>
              <div className="min-w-0"><p className="text-[12px] font-body font-medium text-[#0A0A0A] truncate">Abdul Ahmed</p><p className="text-[10px] font-body text-[#737373] truncate">abdulahmed@xyz.com</p></div>
            </div>
          </div>
        </motion.aside>

        {/* Main content */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <div className="flex items-center justify-end px-6 py-3 border-b border-[#E5E7EB]">
            <div className="flex items-center gap-3">
              <Bell size={18} className="text-[#737373]" />
              <div className="flex items-center gap-2 text-[13px] font-body text-[#737373]"><Monitor size={16} /><span>عربي</span></div>
            </div>
          </div>

          {/* Welcome banner */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="mx-6 mt-6 px-4 py-3 rounded-xl bg-emerald-50 border border-emerald-200 flex items-center gap-3"
          >
            <CheckCircle2 size={18} className="text-emerald-600 flex-shrink-0" />
            <p className="font-body text-sm text-emerald-800">Welcome to the Shafafiya platform</p>
          </motion.div>

          {/* Main text */}
          <div className="flex-1 flex items-center justify-center px-8">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.8, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="text-center"
            >
              <h1 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight text-[#0A0A0A] uppercase">
                Logs in to Shafafiya Portal
              </h1>
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.2 }}
                className="mt-4 font-body text-lg text-[#737373]"
              >
                Abdul Ahmed is now fully onboarded and can access the platform
              </motion.p>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
